function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import FieldWrapper from './FieldWrapper';
import { getValue } from './utils';
import { getAdditionalProps } from '../utils/propTypes';
import * as constants from './constants';

var InputElement = function InputElement(_ref) {
  var disabled = _ref.disabled,
      hasError = _ref.hasError,
      id = _ref.id,
      required = _ref.required,
      maxLength = _ref.maxLength,
      name = _ref.name,
      placeholder = _ref.placeholder,
      role = _ref.role,
      type = _ref.type,
      value = _ref.value,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      inputRef = _ref.inputRef,
      dataAutomation = _ref.dataAutomation,
      suffix = _ref.suffix,
      extraAttrs = _objectWithoutProperties(_ref, ["disabled", "hasError", "id", "required", "maxLength", "name", "placeholder", "role", "type", "value", "onBlur", "onChange", "onFocus", "onKeyDown", "inputRef", "dataAutomation", "suffix"]);

  var handleKeyPressForNumberTypes = function handleKeyPressForNumberTypes(e) {
    var pressedKey = e.key;
    var isDigitKey = /^\d+$/.test(pressedKey);

    if (!isDigitKey) {
      return e.preventDefault();
    }

    return null;
  };

  var inputType = type;
  var extraAttrsRef = extraAttrs;
  var classNames = classnames('eds-field-styled__input', {
    'eds-field-styled__input--has-suffix': suffix
  });

  if (type === 'number') {
    inputType = 'tel';
    extraAttrsRef.onKeyPress = handleKeyPressForNumberTypes;
  }

  return React.createElement("input", _extends({
    "data-spec": "input-field-input-element",
    "aria-invalid": hasError,
    "aria-required": required,
    className: classNames,
    "data-automation": dataAutomation,
    disabled: disabled,
    id: id,
    maxLength: maxLength,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    role: role,
    type: inputType,
    value: value,
    ref: inputRef
  }, extraAttrsRef));
};

var AreaElement = function AreaElement(_ref2) {
  var disabled = _ref2.disabled,
      hasError = _ref2.hasError,
      id = _ref2.id,
      required = _ref2.required,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      role = _ref2.role,
      type = _ref2.type,
      value = _ref2.value,
      onBlur = _ref2.onBlur,
      onChange = _ref2.onChange,
      onFocus = _ref2.onFocus,
      onKeyDown = _ref2.onKeyDown,
      inputRef = _ref2.inputRef,
      dataAutomation = _ref2.dataAutomation,
      suffix = _ref2.suffix,
      extraAttrs = _objectWithoutProperties(_ref2, ["disabled", "hasError", "id", "required", "name", "placeholder", "role", "type", "value", "onBlur", "onChange", "onFocus", "onKeyDown", "inputRef", "dataAutomation", "suffix"]);

  return React.createElement("textarea", _extends({
    "data-spec": "input-field-area-element",
    "aria-invalid": hasError,
    "aria-required": required,
    className: "eds-field-styled__input eds-field-styled__input--multiline",
    "data-automation": dataAutomation,
    "data-suffix": suffix,
    disabled: disabled,
    id: id,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    role: role,
    type: type,
    value: value,
    ref: inputRef
  }, extraAttrs));
};

var InputField =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(InputField, _PureComponent);

  function InputField(props) {
    var _this;

    _classCallCheck(this, InputField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputField).call(this, props));
    var value = getValue(props);
    var shouldFocus = props.shouldFocus;
    _this.state = {
      isActive: props.defaultIsActive || !!shouldFocus,
      value: value
    };
    return _this;
  }

  _createClass(InputField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          defaultIsActive = _this$props.defaultIsActive,
          shouldFocus = _this$props.shouldFocus;

      if (defaultIsActive || shouldFocus) {
        this._focus();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var value = getValue(nextProps);
      var shouldFocus = nextProps.shouldFocus;

      var nextState = _objectSpread({}, this.state);

      if (value !== undefined) {
        nextState = _objectSpread({}, nextState, {
          value: value
        });
      }

      if (shouldFocus !== undefined) {
        nextState = _objectSpread({}, nextState, {
          isActive: shouldFocus
        });
      }

      this.setState(nextState);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$state = this.state,
          isActive = _this$state.isActive,
          value = _this$state.value;
      var _this$props2 = this.props,
          normalizeField = _this$props2.normalizeField,
          normalizer = _this$props2.normalizer,
          name = _this$props2.name;

      if (isActive) {
        this._focus();
      }

      var shouldNormalize = normalizeField && normalizer && value !== normalizer(value);

      if (!isActive && shouldNormalize) {
        normalizeField(name, value, normalizer);
      }
    }
  }, {
    key: "_getRef",
    value: function _getRef(ref) {
      this._input = ref;
      return this._input;
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._input.focus();
    }
  }, {
    key: "_handleBlur",
    value: function _handleBlur() {
      var _this2 = this;

      // This only happens when Google Chrome autofills credit card details or other multi-field data structure.
      // In order to avoid infinite update loops we just ignore events that happen in normally impossible scenarios.
      // Specifically, we don't handle a blur event that happens on an inactive field (fields are inactive when they
      // are not focused so a blur event can't happen organically in this situation).
      if (!this.state.isActive) {
        return;
      }

      this.setState({
        isActive: false
      }, function () {
        if (_this2.props.onBlur) {
          _this2.props.onBlur(_this2.state.value);
        }
      });
    }
  }, {
    key: "_handleChange",
    value: function _handleChange(e) {
      var value = e.target.value;
      this.setState({
        value: value
      });

      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }
  }, {
    key: "_handleFocus",
    value: function _handleFocus() {
      var _this3 = this;

      // This only happens when Google Chrome autofills credit card details or other multi-field data structure.
      // In order to avoid infinite update loops we just ignore events that happen in normally impossible scenarios.
      // Specifically, we don't handle a focus event that happens on an already active field (fields are active when
      // they are focused so a focus event can't happen organically in this situation).
      if (this.state.isActive) {
        return;
      }

      this.setState({
        isActive: true
      }, function () {
        if (_this3.props.onFocus) {
          _this3.props.onFocus(_this3.state.value);
        }
      });
    }
  }, {
    key: "_handleKeyDown",
    value: function _handleKeyDown(event) {
      var onKeyDown = this.props.onKeyDown;

      if (onKeyDown) {
        onKeyDown({
          event: event,
          value: this.state.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          annotationNote = _this$props3.annotationNote,
          bottomSpacing = _this$props3.bottomSpacing,
          disabled = _this$props3.disabled,
          style = _this$props3.style,
          borderType = _this$props3.borderType,
          hasError = _this$props3.hasError,
          id = _this$props3.id,
          isMultiline = _this$props3.isMultiline,
          label = _this$props3.label,
          required = _this$props3.required,
          maxLength = _this$props3.maxLength,
          name = _this$props3.name,
          placeholder = _this$props3.placeholder,
          prefix = _this$props3.prefix,
          role = _this$props3.role,
          suffix = _this$props3.suffix,
          type = _this$props3.type,
          hasMinAsideSpacing = _this$props3.hasMinAsideSpacing,
          minAsideSpacing = _this$props3.minAsideSpacing,
          dataSpec = _this$props3['data-spec'],
          dataAutomation = _this$props3['data-automation'],
          hasCharacterCount = _this$props3.hasCharacterCount,
          linkText = _this$props3.linkText,
          linkSrc = _this$props3.linkSrc;
      var _this$state2 = this.state,
          isActive = _this$state2.isActive,
          value = _this$state2.value;
      var extraAttrs = getAdditionalProps(this);
      var Input = isMultiline ? AreaElement : InputElement;
      var wrapperDataAutomation = dataAutomation ? "".concat(dataAutomation, "-wrapper") : 'input-field-wrapper';
      return React.createElement(FieldWrapper, {
        annotationNote: annotationNote,
        bottomSpacing: bottomSpacing,
        disabled: disabled,
        style: style,
        borderType: borderType,
        hasError: hasError,
        id: id,
        isActive: isActive,
        isMultiline: isMultiline,
        label: label,
        required: required,
        prefix: prefix,
        suffix: suffix,
        value: value,
        hasMinAsideSpacing: hasMinAsideSpacing,
        minAsideSpacing: minAsideSpacing,
        dataSpec: dataSpec,
        dataAutomation: wrapperDataAutomation,
        maxLength: maxLength,
        hasCharacterCount: hasCharacterCount,
        linkText: linkText,
        linkSrc: linkSrc
      }, React.createElement(Input, _extends({}, extraAttrs, {
        dataAutomation: dataAutomation,
        disabled: disabled,
        hasError: hasError,
        id: id,
        required: required,
        maxLength: maxLength,
        name: name,
        onBlur: this._handleBlur.bind(this),
        onChange: this._handleChange.bind(this),
        onFocus: this._handleFocus.bind(this),
        onKeyDown: this._handleKeyDown.bind(this),
        placeholder: value ? null : placeholder,
        role: role,
        type: type,
        value: value,
        inputRef: this._getRef.bind(this),
        suffix: suffix
      })));
    }
  }]);

  return InputField;
}(PureComponent);

_defineProperty(InputField, "propTypes", {
  /**
   * Sets the id for the input element and htmlFor attribute for the label.
   */
  id: PropTypes.string.isRequired,

  /**
   * Content to be displayed as the label of the input element.
   * Required for accessibility reasons but it can be hidden.
   */
  label: PropTypes.node.isRequired,

  /**
   * Content to be displayed as annotation below the input element.
   */
  annotationNote: PropTypes.node,

  /**
   * The amount of spacing for the bottom
   */
  bottomSpacing: PropTypes.number,

  /**
   * Default value of input element.
   * This is the initial value.
   * After the text input has been rendered the first time,
   * if the default value changes, it will *not* update the input.
   */
  defaultValue: PropTypes.string,

  /**
   * Sets disabled attribute to the input element.
   */
  disabled: PropTypes.bool,

  /**
   * Field style chosen for the input. It can be one of: 'dynamic', 'static' or 'basic'.
   * Dynamic: the label is covering the placeholder of the input and moves up when you click the input.
   * Static: the label and the placeholder are always in place and visible.
   * Basic: the label is hidden but still present for accessibility purposes.
   */
  style: PropTypes.oneOf(constants.STYLES),

  /**
   * Field border type chosen for the input. It can be one of: 'default', 'simple' or 'none'.
   * Default: the border changes from grey on idle to a coloured state on focus.
   * Simple: the border preserves its grey colour and has no rounded corners.
   * None: the border is hidden and is replaced by a line below the input to point the writtable area.
   */
  borderType: PropTypes.oneOf(constants.BORDER_TYPES),

  /**
   * Sets error state (adds error classes and aria-invalid).
   */
  hasError: PropTypes.bool,

  /**
   * Changes the input field for a textarea
   */
  isMultiline: PropTypes.bool,

  /**
   * Marks the input as required (adds * and aria-required).
   */
  required: PropTypes.bool,

  /**
   * Sets the max length of the character counter and also limits the
   * number of characters you can input.
   */
  maxLength: PropTypes.number,

  /**
   * Name of input element.
   */
  name: PropTypes.string,

  /**
   * {function} onBlur
   * By default sets isActive state to false and delegates the control to
   * the onBlur function passed as prop.
   */
  onBlur: PropTypes.func,

  /**
   * {function} onChange
   * By default sets the input value to the state and delegates
   * the control to the onChange function passed as prop.
   */
  onChange: PropTypes.func,

  /**
   * {function} onFocus
   * By default sets isActive state to true and delegates the control to
   * the onFocus function passed as prop.
   */
  onFocus: PropTypes.func,

  /**
   * {function} onKeyDown
   * By default triggers the function passed when the user press enter on
   * the field with an object with {event, value}.
   */
  onKeyDown: PropTypes.func,

  /**
   * Placeholder text used to show type of data.
   */
  placeholder: EBPropTypes.translation,

  /**
   * Node to be displayed to the left of the input
   */
  prefix: PropTypes.node,

  /**
   * Sets the role attribute of the input element.
   */
  role: PropTypes.string,

  /**
   * Node to be displayed to the right of the input.
   */
  suffix: PropTypes.node,

  /**
   * Set input type for the input element. Ignored if `isMultiline` is true.
   * Options: text, password, email, url, tel, search, date or number.
   */
  type: PropTypes.oneOf(constants.TYPES),

  /**
   * Value of text input
   * The value can override the default value if specified
   * After the text input has been rendered the first time,
   * if the value changes, it *will* update the input.
   */
  value: PropTypes.string,

  /**
   * Needed for inputs that use an aside element (either prefix or suffix)
   * that is bigger than the normal text size. If the content (maybe a button or icon)
   * is getting cropped on the sides, this lowers the margin allowing it to
   * center within the aside again.
   *
   * NOTE: This property is deprecated in favor of minAsideSpacing.
   */
  hasMinAsideSpacing: PropTypes.bool,

  /**
   * Needed for inputs that use an aside element (either prefix, suffix or both)
   * that is bigger than the normal text size. If the content (maybe a button or icon)
   * is getting cropped on the sides, this lowers the margin allowing it to
   * center within the aside again.
   */
  minAsideSpacing: constants.MIN_ASIDE_SPACING_PROP_TYPES,

  /**
   * Identifier for tests.
   */
  'data-spec': PropTypes.string,

  /**
   * Identifier for automation tests
   */
  'data-automation': PropTypes.string,

  /**
   * Toggles a display of the current character count against the maximum characters allowed in the field.
   */
  hasCharacterCount: PropTypes.bool,

  /**
   * Text for the link to display.
   */
  linkText: PropTypes.string,

  /**
   * Source url of the link to display.
   */
  linkSrc: PropTypes.string,

  /**
  * Default active state of the input field
  */
  defaultIsActive: PropTypes.bool,

  /**
   * Whether or not we should focus the input field
   */
  shouldFocus: PropTypes.bool,

  /**
   * The dragstart event is fired when the user starts dragging an element or text selection.
   * https://developer.mozilla.org/en-US/docs/Web/API/Document/dragstart_event
   *
   * NOTE: This property is usually defined and passed to your form elements by `redux-form`.
   */
  onDragStart: PropTypes.func,

  /**
   * The drop event is fired when an element or text selection is dropped on a valid drop target.
   * https://developer.mozilla.org/en-US/docs/Web/API/Document/drop_event
   *
   * NOTE: This property is usually defined and passed to your form elements by `redux-form`.
   */
  onDrop: PropTypes.func,

  /**
   * Transforms the input field value
   */
  normalizer: PropTypes.func,

  /**
   * Replaces the input field with the normalized value
   */
  normalizeField: PropTypes.func
});

_defineProperty(InputField, "defaultProps", {
  bottomSpacing: 2,
  type: constants.TYPE_TEXT,
  role: 'textbox',
  defaultValue: '',
  isMultiline: false,
  style: constants.STYLE_DYNAMIC,
  borderType: constants.BORDER_DEFAULT,
  'data-spec': 'input-field',
  hasCharacterCount: false,
  defaultIsActive: false
});

export { InputField as default };